export default __webpack_public_path__ + "cfa8946d8dee09f39544666f6f5495d8.jpg";